import { render, staticRenderFns } from "./WaitingProgressBar.vue?vue&type=template&id=b99ec184"
import script from "./WaitingProgressBar.vue?vue&type=script&lang=js"
export * from "./WaitingProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports